import { tools } from './../helpers/tools';
import { settings } from './../settings';
import { VerificationResponse } from '../api/models';
import ajax from '../api/ajax';

class Verification {
    constructor(domain) {
        this.disabled = false;
        this.url = {
            domain: domain,
            path: 'verification/',
        };
    }
    
    init() {
        this.url.domain = settings.settings.acf[`verification_api_url`];
    }
    
    /**
     * Start the verification.
     * @param {Verification} ver
     * @return {Promise<VerificationResponse>} promise
     */
    start(ver) {
        const self = this;

        return new Promise((resolve, reject) => {
            return this.disabled ? resolve(new VerificationResponse()) : ajax.post(self, `start`, true, JSON.stringify(ver)).then((result) => {
                const response = new VerificationResponse(result);

                if (result) {
                    resolve(response);
                } else {
                    reject(response);
                }
            }).catch((error) => {
                const response = new VerificationResponse().failed(error);

                tools.handleError(self, response);

                reject(response);
            });
        });
    }
    
    /**
     * Check the verification if code and token is valid.
     * @param {VerificationCheck} ver
     * @return {Promise<VerificationResponse>} promise
     */
    check(ver) {
        const self = this;
        
        return new Promise((resolve, reject) => {
            return this.disabled ? resolve(new VerificationResponse()) : ajax.post(self, `check`, true, JSON.stringify(ver)).then((result) => {
                const response = new VerificationResponse(result);

                if (result) {
                    resolve(response);
                } else {
                    reject(response);
                }
            }).catch((error) => {
                const response = new VerificationResponse().failed(error);

                tools.handleError(self, response);

                reject(response);
            });
        });
    }
}

export let verification = new Verification();


// WEBPACK FOOTER //
// ./scripts/booking/api/verification.js